module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c05-889a40ba2ff1c53f4a553e1644721917.jpg";